import PageLayout from "../../components/feature/PageLayout";
import ColumnHero from "./components/ColumnHero";
import ColumnList from "./components/ColumnList";

export default function Column() {
  return (
    <PageLayout>
      <ColumnHero />
      <ColumnList />
    </PageLayout>
  );
}
